import script from "./ResourcePost.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourcePost.vue?vue&type=script&setup=true&lang=js"

import "./ResourcePost.vue?vue&type=style&index=0&id=ab03b10e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab03b10e"]])

export default __exports__